import React from 'react';
import { NombreEquipoTorneo } from '../funciones/FuncionesEquipo.js';
import styles from './PosicionesEtapaTorneo.module.css';

const PosicionesEtapaTorneo = (props) => {
  const torneo = props.torneo;
  const posiciones = props.posiciones;

  // onEquipoElegido will be handled by parent via props.onEquipoElegido if needed

  const zonas = posiciones.reduce((accumulator, pos) => {
    const zona = pos.zona || '-';
    if (!accumulator[zona]) accumulator[zona] = [];
    accumulator[zona].push(pos);
    return accumulator;
  }, {});

  return (
    <React.Fragment>
      {Object.entries(zonas).map(([zona, posicionesZona]) => (
        <div key={zona} className={`${styles.cuadro_zona}`}>
          {zona !== '-' && <span className={`${styles.titulo_zona}`}>Zona {zona}</span>}
          <table className={`${styles.tabla_posiciones}`}>
            <thead>
              <tr key={zona}>
                <th>Pos.</th>
                <th>Equipo</th>
                <th>Pts.</th>
                <th>PJ</th>
                <th>PG</th>
                <th>PE</th>
                <th>PP</th>
                <th>GF</th>
                <th>GC</th>
              </tr>
            </thead>
            <tbody>
              {posicionesZona &&
                posicionesZona.map((item) => (
                  <tr key={zona + '-' + item.posicion}>
                    <td className={`${styles.posicion}`}>{item.posicion}</td>
                    <td className={`${styles.equipo}`}>
                      {NombreEquipoTorneo(item.equipo, torneo)}
                    </td>
                    <td className={`${styles.puntos}`}>{item.puntos}</td>
                    <td className={`${styles.partidos}`}>{item.partidosJugados}</td>
                    <td className={`${styles.partidos}`}>{item.partidosGanados}</td>
                    <td className={`${styles.partidos}`}>{item.partidosEmpatados}</td>
                    <td className={`${styles.partidos}`}>{item.partidosPerdidos}</td>
                    <td className={`${styles.goles}`}>{item.golesAFavor}</td>
                    <td className={`${styles.goles}`}>{item.golesEnContra}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ))}
    </React.Fragment>
  );
};

export default PosicionesEtapaTorneo;
